export default __webpack_public_path__ + "media/images/casatb/tenant/timeline-two-4d4c7df0dd53b45e38785ccfdc3b9c1c.png";